import { render } from "./RedCheckoutSuccessContentStandard.vue?vue&type=template&id=91a4306e&scoped=true&ts=true"
import script from "./RedCheckoutSuccessContentStandard.vue?vue&type=script&lang=ts"
export * from "./RedCheckoutSuccessContentStandard.vue?vue&type=script&lang=ts"

import "./RedCheckoutSuccessContentStandard.vue?vue&type=style&index=0&id=91a4306e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91a4306e"]])

export default __exports__